module.exports = __webpack_public_path__ + "static/media/stats-chart.42d1dae9.svg";